// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import wNumb from 'wnumb';
import {dispatchEvent} from 'fg-frontend/src/lib/dom';

const normalizeValue = ({ value, step, max, min, defaultValue = 0 }) => {
  let normalizedValue = Number(String(value || defaultValue).replace(",", "."));

  if (min != null && normalizedValue <= min) {
    normalizedValue = Math.max(normalizedValue, min);
  }
  if (max != null && normalizedValue >= max) {
    normalizedValue = Math.min(normalizedValue, max);
  }
  return normalizedValue;
};
const FRAGMENT = {
  component: '[data-fragment="component"]',
  container: '[data-fragment="container"]',
  selected: '[data-fragment="selected"]',
  selectedTrigger: '[data-fragment="selected-trigger"]',
  radio: '[data-fragment="component-radio"]',
  valueField: '[data-fragment="value-field"]',
  inputMin: '[data-fragment="input-min"]',
  inputMax: '[data-fragment="input-max"]',
  customRange: '[data-fragment="custom-range"]',
  selectedCustomRange: '[data-fragment="selected-custom-range"]',
};
const VALIDATION_TIMEOUT = 1000;

class PriceFilter extends WebComponent {
  constructor(props) {
    super(props);

    this.setRadioValues = this.setRadioValues.bind(this);
    this.handleSelectedClick = this.handleSelectedClick.bind(this);
    this.handleSelectedClose = this.handleSelectedClose.bind(this);

    let {
      startMin, startMax,
      valueFormat: { thousandsSep, decimalPoint },
    } = this.props;

    this.numberFormat = wNumb({
      decimals: this.decimals,
      mark: decimalPoint,
      thousand: thousandsSep,
    });

    this.state = {
      input: {
        values: { min: startMin, max: startMax },
        limits: {
          inputMin: { startMin, startMax },
          inputMax: { startMin, startMax },
        },
      },
      formattedInput: {
        min: this.numberFormat.to(startMin),
        max: this.numberFormat.to(startMax),
      },
      tempInput: null, // při zadávání inputu se sem vkládá nevalidovaný input, zároveň slouží jako kontrola k vystřelení change event
    };
  }

  didMount() {
    this.component = this.element.querySelector(FRAGMENT.component);
    this.container = this.element.querySelector(FRAGMENT.container);
    this.selected = this.element.querySelector(FRAGMENT.selected);
    this.selectedTrigger = this.element.querySelector(FRAGMENT.selectedTrigger);
    this.valueField = this.element.querySelector(FRAGMENT.valueField);
    this.inputMin = this.element.querySelector(FRAGMENT.inputMin);
    this.inputMax = this.element.querySelector(FRAGMENT.inputMax);
    this.radios = this.element.querySelectorAll(FRAGMENT.radio);
    this.customRange = this.element.querySelector(FRAGMENT.customRange);
    this.selectedCustomRange = this.element.querySelector(FRAGMENT.selectedCustomRange);
    this.initialState = false;

    if (this.inputMin && this.inputMax) {
      // listenery
      this.selectedInput = undefined;
      [this.inputMin, this.inputMax].forEach((el) => {
        // input se při prvním kliku selectne
        el.parentElement.addEventListener('click', () => {
          if (this.selectedInput !== el) {
            el.select();
            this.selectedInput = el;
          }
        });
        el.addEventListener('blur', () => { this.selectedInput = undefined; });

        el.addEventListener('focus', this.handleInputFocus);
        el.addEventListener('blur', this.handleInputBlur);
        el.addEventListener('input', this.handleInputChange);
      });
    }
    if (this.radios) {
      const {
        min,max,
        startMin, startMax,
      } = this.props;

      const radiosSize = this.radios.length;
      let radioChecked = false;

      this.radios.forEach((el) => {
        if ((min == el.getAttribute('data-min-value') || startMin == el.getAttribute('data-min-value')) && (max == el.getAttribute('data-max-value') || startMax == el.getAttribute('data-max-value'))) {
          el.checked = true;
          radioChecked = true;
        }
        el.addEventListener('click', this.setRadioValues);
      });

      if (((this.getValueFromUrl(this.inputMin) != '' || this.getValueFromUrl(this.inputMax) != '') || window.location.pathname == '/') &&  (!radioChecked)) {
        this.radios[radiosSize - 1].checked = true;
        this.initialState = true;
        dispatchEvent(this.radios[radiosSize - 1],'click');
      }
    }
    if (this.selected && this.selectedTrigger) {
      this.selectedTrigger.addEventListener('click', this.handleSelectedClick);
      document.addEventListener('click', this.handleSelectedClose);
    }
  }

  // listener na otvirani "popupu"
  handleSelectedClick() {
    this.selected.classList.toggle('open');
    this.container.classList.toggle('open');
  }
  handleSelectedClose(e) {
    const isClickInside = this.selected.contains(e.target);

    if (!isClickInside && this.selected.classList.contains('open')) {
      this.selected.classList.remove('open');
      this.container.classList.remove('open');
    }
  }

  // listener z radio buttonu
  setRadioValues(el) {
    const { input: { values, limits } } = this.state;
    const setCustomRange = (el.target.getAttribute('data-set-custom-range') === 'true') || false;
    const radioMin = el.target.getAttribute('data-min-value');
    const radioMax = el.target.getAttribute('data-max-value');

    if (setCustomRange) {
      this.customRange.classList.remove('hidden');
      if (this.initialState || this.selectedCustomRange) {
        if (this.selectedCustomRange) {
          this.inputMin.value = this.selectedCustomRange.getAttribute('data-custom-min');
          this.inputMax.value = this.selectedCustomRange.getAttribute('data-custom-max');
        }
        else {
          this.inputMin.value = this.getValueFromUrl(this.inputMin);
          this.inputMax.value = this.getValueFromUrl(this.inputMax);
        }
      }
      else {
        this.inputMin.value='';
        this.inputMax.value='';
      }
      this.inputMin.focus();
    }
    else {
      const hiddenInput = document.querySelector('#PriceFilter_O');
      if (hiddenInput) {
        hiddenInput.parentNode.removeChild(hiddenInput);
      }

      this.customRange.classList.add('hidden');
      this.valueField.value = `${radioMin},${radioMax}`;
      this.inputMin.value = radioMin;
      this.inputMax.value = radioMax;
    }
  }

  getValueFromUrl(input) {
    const inputName = input.name;
    let result = '';
    const urlString = window.location.search.split('&');

    urlString.forEach((urlItem, i) => {
      if (urlItem.indexOf(inputName) != -1) {
        result = urlItem.split('=')[1];
      }
    });

    return result;
  }

  // input listenery z NumberInput
  handleInputFocus = () => {
    window.addEventListener('keydown', this.handleInputKeyPress);
  };
  handleInputBlur = () => {
    window.removeEventListener('keydown', this.handleInputKeyPress);
    clearTimeout(this.validationTimeout);
    this.handleInputUpdate();
  };
  handleInputKeyPress = (e) => {
    const { ctrlKey, key } = e;
    const floatValidChar = /^[0-9]|,|\.|-$/;
    const integerValidChar = /^[0-9]|-$/;
    if (!ctrlKey) {
      const pattern = this.decimals === 0 ? integerValidChar : floatValidChar;
      const result = pattern.test(key);
      const validKeys = ['ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Tab'];
      if (!result && !validKeys.includes(key)) {
        e.preventDefault();
      }
      // comma or dot only once
/*      if ((key === '.' || key === ',') && (value.toString().indexOf('.') !== -1 || value.toString().indexOf(',') !== -1)) {
        e.preventDefault();
      }*/
    }
  }
  handleInputChange = (e, inc) => {
    const { input: { values, limits }, formattedInput } = this.state;
    const handledInput = e.target.dataset.fragment;
    const value = e.currentTarget.value;
    const newValue = normalizeValue({
      value: inc ? (inc > 0 ? value - (10 ** -this.decimals) : +value + (10 ** -this.decimals)) : value,
      step: 10 ** -this.decimals,
      min: handledInput === 'input-min' ? limits.inputMin.min : limits.inputMax.min,
      max: handledInput === 'input-min' ? limits.inputMin.max : limits.inputMax.max,
    });

    this.setState({
      tempInput: handledInput === 'input-min' ? { min: newValue, max: values.max } : { min: values.min, max: newValue },
    });
    // autovalidace po timeoutu
    clearTimeout(this.validationTimeout);
    this.validationTimeout = setTimeout(() => this.handleInputUpdate(), VALIDATION_TIMEOUT);
  };

  handleInputUpdate = () => {
    const { tempInput, input: { limits } } = this.state;
    if (tempInput) {
      this.setState({
        input: {
          values: tempInput,
          limits,
        },
        tempInput: null,
        formattedInput: {
          min: this.numberFormat.to(tempInput.min),
          max: this.numberFormat.to(tempInput.max),
        },
      });
    }
    if (tempInput) {
      this.update();
      this.dispatchChangeEvent();
    }
  }

  update() {
    const { disabled, originalMin, originalMax } = this.props;
    const { input: { values }} = this.state;

    if ((values.max == '') || (values.max == '0')) {
      values.max = originalMax;
    }
    if ((values.min == '')) {
      values.min = originalMin;
    }

    if (values.max < values.min) {
      values.max = values.min + 100;
    }

    if (!Number.isInteger(values.min)) {
      values.min = parseFloat(values.min).toFixed(2);
    }
    if (!Number.isInteger(values.max)) {
      values.max = parseFloat(values.max).toFixed(2);
    }

    if (this.valueField) this.valueField.value = `${values.min},${values.max}`;

    if (disabled) {
      if (this.inputMin && this.inputMax) {
        this.inputMin.disabled = true;
        this.inputMax.disabled = true;
      }
    }
  }

  willUnMount() {
    this.component = undefined;
    this.valueField = undefined;
    this.inputMin = undefined;
    this.inputMax = undefined;
    this.radios = undefined;

    window.removeEventListener('keydown', this.handleKeyPress);

    if (this.selected && this.selectedTrigger) {
      this.selectedTrigger.removeEventListener('click', this.handleSelectedClick);
      document.removeEventListener('click', this.handleSelectedClose);
    }

    clearTimeout(this.validationTimeout);
  }
}

PriceFilter.defaultProps = {
  disabled: false,
  inputMin: null,
  inputMax: null,
  valueFormat: {
    thousandsSep: '',
    decimalPoint: ',',
  }
};

export default PriceFilter;



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/PriceFilter.js